import { render, staticRenderFns } from "./Ipmanlist.vue?vue&type=template&id=7ccb4588&"
import script from "./Ipmanlist.vue?vue&type=script&lang=js&"
export * from "./Ipmanlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports